import charityy from "./video/charityy.mp4";
import ReactPlayer from 'react-player';

const About = () => {

    return ( 
		<>
			<div class="home_what" id="intro">
         <div class="container">
            <div class="home_welcome aos-init aos-animate" data-aos="fade-up" data-aos-duration="1000">
               <h3>The Home of the Crypto Pilots</h3>
               <a href="https://opensea.io/collection/uss-crypto-pilots" class="btn" target="_blank"><span> VIEW THE WHOLE COLLECTION </span></a>
            </div>
            <div class="what_flex">
               <div class="what_inner">
                  <div class="what_inner_text visible-xs aos-init aos-animate" data-aos="fade-up" data-aos-duration="1000">
                     <h3><em>ABOUT</em>US</h3>
                  </div>
                  <div class="what_inner_img aos-init aos-animate" data-aos="fade-right" data-aos-duration="1000">
                     <img src="images/about.png" title="" alt=""/>
                     <div class="round_icon round_icon1">
                        <img src="images/8.png" title="" alt=""/>   
                     </div>
                     <div class="round_icon round_icon2">
                        <img src="images/14.jpg" title="" alt=""/>   
                     </div>
                     <div class="round_icon round_icon3">
                        <img src="images/98.png" title="" alt=""/>   
                     </div>
                  </div>
               </div>
               <div class="what_inner">
                  <div class="what_inner_text aos-init aos-animate" data-aos="fade-left" data-aos-duration="1000">
                     <h3 class="hidden-xs"><em>ABOUT</em> US</h3>
                     <p>A group of 2222 rogue Crypto Pilots decided to leave and wander off into space. Now, they orbit the Earth in the Universal Space Station with a mission to strengthen their community, happiness, and wealth. While exploring space they form new multi-galactic alliances and discover new technologies of ancient wisdom. As they traverse the universe, the group slowly grew in numbers and is now preparing to head back to their home planet to bring enlightenment to all.</p>
                     <div class="join_btn">
                        <a target="_blank" href="https://discord.gg/46UEWpPQkt" class="btn"> <img src="images/btn_img2.png" title="" alt=""/> <span>JOIN OUR DISCORD</span></a>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>

               
		{/* Video explainer */}
		<div className="vieo-explain">
			<div className="container">
				<div className="video-expainer-wrapper">
               <h1>Our official partner: Vast Self Charity.</h1>
               {/* <video autoPlay loop  className="vid-bgg">
                 <source src={ charityy } type="video/mp4"/>
              </video> */}
              <ReactPlayer url='https://youtu.be/6Iqm-JYHJ7k' className= 'video' controls={true} />
            </div>
			</div>
		</div>
	</>
        
     );
}
 
export default About;